import {
   SetCompletionsAction,
   CompletionsErrorAction,
   CompletionsActionType,
   CompletionMap,
} from './completions.actions';

export interface CompletionsState {
   teamCompletions: CompletionMap;
   userCompletions: CompletionMap;
   courseCompletions: CompletionMap;
   error: string;
}

const initialState: CompletionsState = {
   teamCompletions: [],
   userCompletions: [],
   courseCompletions: [],
   error: null,
};

type Actions = SetCompletionsAction & CompletionsErrorAction;

export const completionsReducer = (
   state: CompletionsState = initialState,
   action: Actions
): CompletionsState => {
   switch (action.type) {
      case CompletionsActionType.SET_TEAM_COMPLETIONS: {
         return {
            ...state,
            teamCompletions: action.completionPercents,
            error: null,
         };
      }
      case CompletionsActionType.SET_USER_COMPLETIONS: {
         return {
            ...state,
            userCompletions: action.completionPercents,
            error: null,
         };
      }
      case CompletionsActionType.SET_COURSE_COMPLETIONS: {
         return {
            ...state,
            courseCompletions: action.completionPercents,
            error: null,
         };
      }
      case CompletionsActionType.COMPLETIONS_ERROR: {
         return {
            ...state,
            error: action.error,
         };
      }
      default: {
         return state;
      }
   }
};

export const COMPLETIONS_STATE_ROOT = 'completionsState';

export const teamCompletionSelector = (teamid: number): ((state: any) => number) => {
   return state => {
      const completionsState: CompletionsState = state[COMPLETIONS_STATE_ROOT];

      if (completionsState.error) {
         return 0;
      }

      const teamCompletions: CompletionMap = completionsState.teamCompletions;
      return !state.error && teamCompletions ? teamCompletions[teamid] : null;
   };
};

export const userCompletionSelector = (userid: number): ((state: any) => number) => {
   return state => {
      const completionsState: CompletionsState = state[COMPLETIONS_STATE_ROOT];

      if (completionsState.error) {
         return 0;
      }

      const userCompletions: CompletionMap = completionsState.userCompletions;
      return !state.error && userCompletions ? userCompletions[userid] : null;
   };
};

export const courseCompletionSelector = (wikiid: number): ((state: any) => number) => {
   return state => {
      const completionsState: CompletionsState = state[COMPLETIONS_STATE_ROOT];

      if (completionsState.error) {
         return 0;
      }

      const courseCompletions: CompletionMap = completionsState.courseCompletions;
      return courseCompletions ? courseCompletions[wikiid] : null;
   };
};
